// extracted by mini-css-extract-plugin
export var circle = "_gk-1";
export var exitConfirmationModal = "_gk-5";
export var iframe = "_gk-0";
export var offline = "_gk-3";
export var online = "_gk-2";
export var workstationSelectError = "_gk-4";